import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { DropDownInputDto } from '../../../../../models/aggregates/drop-down/drop-down-input.dto';
import { ApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class DropDownService extends BaseApiTemplateService <ApiResponseModel<any>> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'drop-down';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'drop-down';

    this.httpClient = http;
  }

  getPrintableFormatTxnType(dropDownInputDto: DropDownInputDto, visa: ApiVisa) {
    let url = visa.api_domain_url +this.endpoint_path + '/printable-format-txn-type';
    return this.httpClient.post<ApiResponseModel<any>>(
        url,
        dropDownInputDto,
        this.getHttpHeader(visa)
      );

  }

}